/**
 * Migrációs lépés azonosítók a DÜP migrációs folyamat követéséhez.
 * Ezek az értékek kerülnek az adatbázisba (LastStepId mező).
 */
export const MIGRATION_STEPS = {
  // Group1 (online verifikáció) lépések
  G1_INTRO_SHOWN: '10_G1_INTRO_SHOWN',
  G1_PHONE_SCREEN_SHOWN: '20_G1_PHONE_SCREEN_SHOWN',
  G1_PHONE_SELECTED: '30_G1_PHONE_SELECTED',
  G1_PHONE_ENTERED: '40_G1_PHONE_ENTERED',
  G1_SMS_SENT: '50_G1_SMS_SENT',
  G1_SMS_VERIFIED: '60_G1_SMS_VERIFIED',
  G1_SUCCESS: '70_G1_SUCCESS',
  G1_LOCKOUT: '80_G1_LOCKOUT',
  G1_ERROR: '90_G1_ERROR',

  // Group2 (személyes azonosítás szükséges) lépések
  G2_INTRO_SHOWN: '10_G2_INTRO_SHOWN',
  G2_DAP_CODE_SHOWN: '20_G2_DAP_CODE_SHOWN',
  G2_DAP_VERIFIED: '30_G2_DAP_VERIFIED',
  G2_SUBSCRIBER_SELECTED: '40_G2_SUBSCRIBER_SELECTED',
  G2_EMAIL_CONFIRMED: '50_G2_EMAIL_CONFIRMED',
  G2_PHONE_VERIFIED: '60_G2_PHONE_VERIFIED',
  G2_SUCCESS: '70_G2_SUCCESS',
  G2_LOCKOUT: '80_G2_LOCKOUT',
  G2_APPOINTMENT_BOOKED: '90_G2_APPOINTMENT_BOOKED',
  G2_ERROR: '100_G2_ERROR',
} as const;

export type MigrationStep = (typeof MIGRATION_STEPS)[keyof typeof MIGRATION_STEPS];